module.exports = __webpack_public_path__ + "static/img/shopeepay-icon.f8e061e0.png";